// Refine
import { useTranslation } from '@refinedev/core';

// Mantine
import { Flex, Text } from '@mantine/core';
import { DatePicker, DatePickerPreset } from '@mantine/dates';
import { getDatePickerPresetRanges } from 'utils/dateUtils';
import { useCurrentSiteStore } from 'store';

interface DatePickerWithPresetsProps {
  dateRange: [string, string];
  setDateRange: (value: [string, string]) => void;
  fiscalYearEndMonth?: number; // 1-12
  includeHelpText?: boolean;
}
export const DatePickerWithPresets: React.FC<DatePickerWithPresetsProps> = ({
  dateRange,
  setDateRange,
  fiscalYearEndMonth = 12,
  includeHelpText = true,
}) => {
  const { translate } = useTranslation();
  const { timezone } = useCurrentSiteStore();
  const presetRanges = getDatePickerPresetRanges({
    timezone,
    fiscalYearEndMonth,
  });

  const presets: DatePickerPreset<'range'>[] = [
    {
      value: presetRanges.yearToDate,
      label: translate('components.datePickerWithPresets.yearToDate'),
    },
    {
      value: presetRanges.lastMonth,
      label: translate('components.datePickerWithPresets.lastMonth'),
    },
    {
      value: presetRanges.lastQuarter,
      label: translate('components.datePickerWithPresets.lastQuarter'),
    },
    {
      value: presetRanges.lastFiscalYear,
      label: translate('components.datePickerWithPresets.lastFiscalYear'),
    },
    {
      value: presetRanges.allTime,
      label: translate('components.datePickerWithPresets.allTime'),
    },
    {
      value: ['', ''],
      label: translate('components.datePickerWithPresets.customRange'),
    },
  ];

  return (
    <Flex gap="md" direction="column" align={'center'} w="100%">
      {includeHelpText && (
        <Text size="sm" c="dimmed">
          {translate('components.datePickerWithPresets.helpText')}
        </Text>
      )}
      <DatePicker
        type="range"
        value={dateRange}
        onChange={(val) => {
          const next = val as [string, string];
          setDateRange(next);
        }}
        presets={presets}
        allowSingleDateInRange
      />
    </Flex>
  );
};
